import React from 'react';
import { useRevealAnimation } from '@/hooks/useRevealAnimation';

type ComparisonTableProps = {
  headers: string[];
  rows: string[][];
};

export const ComparisonTable: React.FC<ComparisonTableProps> = ({
  headers,
  rows,
}) => {
  const { ref, isVisible } = useRevealAnimation();

  return (
    <div
      ref={ref}
      className={`my-24 max-w-4xl mx-auto transform transition-all duration-700 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
    >
      {/* Headers - visible only on desktop */}
      <div
        className={`hidden md:grid md:grid-cols-2 md:gap-24 mb-12 transform transition-all duration-700 delay-100 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
        }`}
      >
        {headers.map((header, index) => (
          <div
            key={index}
            className={`text-lg font-medium text-zinc-500 dark:text-zinc-400 ${
              index === 1 ? 'text-right' : ''
            }`}
          >
            {header}
          </div>
        ))}
      </div>

      {/* Rows */}
      <div className="space-y-24">
        {rows.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className={`grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-24 border-t border-zinc-200 dark:border-zinc-800 pt-12 transform transition-all duration-700 ${
              isVisible
                ? 'translate-y-0 opacity-100'
                : 'translate-y-8 opacity-0'
            }`}
            style={{ transitionDelay: `${200 + rowIndex * 150}ms` }}
          >
            {/* First column */}
            <div>
              {/* Label - visible only on mobile */}
              <div className="md:hidden text-lg font-medium text-zinc-500 dark:text-zinc-400 mb-3">
                {headers[0]}
              </div>
              <div className="text-2xl font-normal text-zinc-900 dark:text-zinc-100">
                {row[0]}
              </div>
            </div>

            {/* Second column */}
            <div>
              {/* Label - visible only on mobile */}
              <div className="md:hidden text-lg font-medium text-zinc-500 dark:text-zinc-400 mb-3">
                {headers[1]}
              </div>
              <div className="text-lg md:text-right font-normal text-zinc-700 dark:text-zinc-300">
                {row[1]}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
